// MAKER LIST
export const FETCH_MAKER_LIST_REQUEST = 'FETCH_MAKER_LIST_REQUEST';
export const FETCH_MAKER_LIST_SUCCESS = 'FETCH_MAKER_LIST_SUCCESS';
export const FETCH_MAKER_LIST_ERROR = 'FETCH_MAKER_LIST_ERROR';
export const SHOW_MAKER_LOADER = 'SHOW_MAKER_LOADER';
export const HIDE_MAKER_LOADER = 'HIDE_MAKER_LOADER';
export const GENERATE_MAKER_REPORT_REQUEST = 'GENERATE_MAKER_REPORT_REQUEST';
export const GENERATE_MAKER_REPORT_SUCCESS = 'GENERATE_MAKER_REPORT_SUCCESS';
export const GENERATE_MAKER_REPORT_ERROR = 'GENERATE_MAKER_REPORT_ERROR';
export const DOWNLOAD_MAKER_REPORT_REQUEST = 'DOWNLOAD_MAKER_REPORT_REQUEST';
export const DOWNLOAD_MAKER_REPORT_SUCCESS = 'DOWNLOAD_MAKER_REPORT_SUCCESS';
export const DOWNLOAD_MAKER_REPORT_ERROR = 'DOWNLOAD_MAKER_REPORT_ERROR';
export const GET_ACTIVE_MAKER_REPORT_REQUEST = 'GET_ACTIVE_MAKER_REPORT_REQUEST';
export const GET_ACTIVE_MAKER_REPORT_SUCCESS = 'GET_ACTIVE_MAKER_REPORT_SUCCESS';
export const GET_ACTIVE_MAKER_REPORT_ERROR = 'GET_ACTIVE_MAKER_REPORT_ERROR';
export const GET_STATIC_DATA_REQUEST_MAKER = 'GET_STATIC_DATA_REQUEST_MAKER';
export const GET_STATIC_DATA_SUCCESS_MAKER = 'GET_STATIC_DATA_SUCCESS_MAKER';
export const GET_STATIC_DATA_ERROR_MAKER = 'GET_STATIC_DATA_ERROR_MAKER';
export const FETCH_MAKER_LIST = 'FETCH_MAKER_LIST'
